import axios from 'axios';
import { set } from 'lodash';
import { enqueueSnackbar } from 'notistack';
import axiosInstance, { endpoints } from 'src/utils/axios';




let uploadProgress;
let uploadProgressContributor;
let uploadProgressTraineeAdd;
let uploadProgressTraineeProfil;


let loadIsCanceled = false
let loadContributorAddIsCanceled = false
let loadTraineeAddIsCanceled = false
let loadTraineeProfilIsCanceled = false



let loadIsCompleted = false
let loadContributorAddIsCompleted = false
let loadTraineeAddIsCompleted = false;
let loadTraineeProfilIsCompleted = false;



let uplaodImgStart = false
let ContributorAdduplaodImgStart = false
let TraineeAdduplaodImgStart = false
let TraineeProfiluplaodImgStart = false


export const setUploadProgress = ( pathCall, progress ) =>
{

       if ( pathCall === 'contributorAdd' )
       {
              uploadProgressContributor = progress;
              // uploadProgress = null
              if ( progress === 100 )
              {

                     // console.log( 'add add add' );

                     uploadProgressContributor = 101;
                     loadContributorAddIsCompleted = true
              }
       }



       if ( pathCall === 'contributorprofil' )
       {
              uploadProgress = progress;
              // uploadProgressContributor = null
              if ( progress === 100 )
              {
                     // console.log( 'profil profil profil' );
                     uploadProgress = 101;
                     loadIsCompleted = true
              }
       }









       if ( pathCall === 'traineeAdd' )
       {
              uploadProgressTraineeAdd = progress;
              // uploadProgressContributor = null
              if ( progress === 100 )
              {
                     // console.log( 'profil profil profil' );
                     uploadProgressTraineeAdd = 101;
                     loadTraineeAddIsCompleted = true
              }
       }





       if ( pathCall === 'traineeprofil' )
       {
              uploadProgressTraineeProfil = progress;
              // uploadProgressContributor = null
              if ( progress === 100 )
              {
                     // console.log( 'profil profil profil' );
                     uploadProgressTraineeProfil = 101;
                     loadTraineeProfilIsCompleted = true
              }
       }






};

export const getUploadProgress = () => uploadProgress;
export const getUploadProgressAddContributor = () => uploadProgressContributor;
export const getUploadProgressAddTrainee = () => uploadProgressTraineeAdd;
export const getUploadProgressProfilTrainee = () => uploadProgressTraineeProfil;



export const loadIsCancel = () => loadIsCanceled
export const loadContributorAddIsCancel = () => loadContributorAddIsCanceled
export const loadTraineeAddIsCancel = () => loadTraineeAddIsCanceled
export const loadTraineeProfilIsCancel = () => loadTraineeProfilIsCanceled



export const loadIsComplete = () => loadIsCompleted
export const loadContributorAddIsComplete = () => loadContributorAddIsCompleted
export const loadTraineeAddIsComplete = () => loadTraineeAddIsCompleted
export const loadTraineeProfilIsComplete = () => loadTraineeProfilIsCompleted


export const resetLoadIsComplete = () =>
{
       uploadProgressTraineeProfil = 0;
       uploadProgressTraineeAdd = 0;
       uploadProgressContributor = 0;
       uploadProgress = 0;

       loadIsCompleted = false;
       loadContributorAddIsCompleted = false;
       loadTraineeAddIsCompleted = false;
       loadTraineeProfilIsCompleted = false;


       loadIsCanceled = false
       loadContributorAddIsCanceled = false
       loadTraineeAddIsCanceled = false
       loadTraineeProfilIsCanceled = false



}
export const setuploadImgStart = ( valGet ) => { uplaodImgStart = valGet }
export const setContributorAdduplaodImgStart = ( valGet ) => { ContributorAdduplaodImgStart = valGet }
export const setTraineeAdduplaodImgStart = ( valGet ) => { TraineeAdduplaodImgStart = valGet }
export const setTraineeProfiluplaodImgStart = ( valGet ) => { TraineeProfiluplaodImgStart = valGet }


export const getuploadImgStart = () => uplaodImgStart
export const getContributorAdduplaodImgStart = () => ContributorAdduplaodImgStart
export const getTraineeAdduplaodImgStart = () => TraineeAdduplaodImgStart
export const getTraineeProfiluplaodImgStart = () => TraineeProfiluplaodImgStart






export async function getUser( userID )
{
       // console.log(`Envoi d'une requête pour récupérer l'utilisateur avec ID ${userID}`);

       const response = await axiosInstance.get( `${ endpoints.user.get }/${ userID }` );

       return response.data;

}

export async function addUser( userData )
{
       // console.log("Envoi d'une requête pour ajouter un nouvel utilisateur:", userData);

       const response = await axiosInstance.post( endpoints.user.addUser, { ...userData } );

       return response.data;

}

export async function addProfilUser( userData )
{
       // console.log("Envoi d'une requête pour ajouter un nouvel utilisateur:", userData);

       const response = await axiosInstance.post( endpoints.user.addUserProfil, { ...userData } );
       return response.data;

}















export async function updatePassword( PasswordObject ) 
{

       try
       {

              const response = await axiosInstance.post( endpoints.user.updatePassword, { ...PasswordObject } );
              return response.data;

       } catch ( error ) 
       {

              ShowPasswordError( error )
              throw error;

       }
}













// Fonction pour gérer l'annulation

export async function uploadImage( imageObject, cancelToken, pathCall )
{
       try
       {
              // console.log( 'appelr' );

              // Crée un objet FormData
              loadIsCanceled = false
              loadContributorAddIsCanceled = false
              loadTraineeAddIsCanceled = false
              loadTraineeProfilIsCanceled = false



              uplaodImgStart = true
              ContributorAdduplaodImgStart = true
              TraineeAdduplaodImgStart = true
              TraineeProfiluplaodImgStart = true

              const formData = new FormData();
              formData.append( 'image', imageObject ); // Ajoute l'image au FormData

              // Envoie la requête avec FormData et gestion de la progression
              const response = await axiosInstance.post( endpoints.user.uploadImage, formData, {
                     headers: {
                            'Content-Type': 'multipart/form-data',
                     },
                     onUploadProgress: ( progressEvent ) =>
                     {
                            const progress = Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total );

                            if ( pathCall === 'contributorAdd' )
                            {

                                   setUploadProgress( 'contributorAdd', progress );

                                   // console.log( 'progression de l\'upload de l\'inage contributor  get', getUploadProgressAddContributor() );

                            }


                            if ( pathCall === 'contributorprofil' )
                            {
                                   setUploadProgress( 'contributorprofil', progress );

                                   // console.log( 'progression de l\'upload de l\'inage profil call', progress );

                            }



                            if ( pathCall === 'traineeAdd' )
                            {
                                   setUploadProgress( 'traineeAdd', progress );

                                   // console.log( 'progression de l\'upload de l\'inage traineeAdd', progress );

                            }



                            if ( pathCall === 'traineeprofil' )
                            {
                                   setUploadProgress( 'traineeprofil', progress );

                                   // console.log( 'progression de l\'upload de l\'inage traineeprofil traineeprofil', progress );

                            }

                     },

                     cancelToken


              } );

              return response.data;
       } catch ( error )
       {
              if ( axios.isCancel( error ) )
              {
                     // console.log( 'Upload annulé', error.message );
                     loadIsCanceled = true
                     loadContributorAddIsCanceled = true
                     loadTraineeAddIsCanceled = true
                     loadTraineeProfilIsCanceled = true

              } else
              {
                     // console.log( error );
                     loadIsCanceled = true
                     loadContributorAddIsCanceled = true
                     loadTraineeAddIsCanceled = true
                     loadTraineeProfilIsCanceled = true

                     throw error;
              }
              return null; // ou une autre valeur par défaut

       }
}














function ShowPasswordError( error )
{

       // console.log('errrrooooooooooooooo',error);


       if ( error.error === undefined )
       {

              const errorTabs = error.errors.new_password


              if ( Array.isArray( errorTabs ) && errorTabs.every( item => typeof item === 'string' ) ) 
              {

                     errorTabs.forEach( ( errGet ) =>
                     {

                            enqueueSnackbar( errGet, { variant: 'error' } );

                     } )
              }

       } else
       {

              enqueueSnackbar( error.error, { variant: 'error' } );

       }

}